<div class="pb-plus pt-huge">
  <ngx-status-result
    (clicked)="checkClick($event)"
    [buttons]="config().buttons"
    [description]="config().description"
    [title]="config().title"
    [type]="'Empty'"
    [iconState]="'warning'"
  >
  </ngx-status-result>
</div>
